import {getEventDescription} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import {useAppSelector} from '../../../../hooks/runtime'
import {useVisibilityStyles} from '../../../../hooks/use-visibility-styles'
import {getEvent} from '../../../../selectors/event'
import cl from '../../../classnames.scss'
import s from './description.scss'

export const Description = () => {
  const event = useAppSelector(getEvent)
  const {
    allBreakpoints: {isSideBySideHeaderLayout},
  } = useVisibilityStyles()

  const description = getEventDescription(event)
  const sideBySideHeaderLayout = isSideBySideHeaderLayout()

  return description ? (
    <div className={s.descriptionSpacing}>
      <p
        className={classNames(s.eventDescription, cl.evDescriptionFont, cl.evDescriptionColor, {
          [s.sideBySide]: sideBySideHeaderLayout,
        })}
        data-hook={DH.headerEventDescription}
      >
        {description}
      </p>
    </div>
  ) : null
}
